export default __webpack_public_path__ + "static/media/export2.9497e2f9.svg";